var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-circle",style:("background:url(" +
    _vm.photoUrl +
    ") center/cover;\n                  padding: 50%")})}
var staticRenderFns = []

export { render, staticRenderFns }